module.exports = __webpack_public_path__ + "img/logo1.78e1abae.svg";